import React from 'react'
import styled from '@emotion/styled'
import { FlexRowDiv, ModalContentNormal } from '../generic/Basics'
import Modal from '../layout/Modal'
import Button from '../generic/button'
import { fontSizeSmall, fontSize2XSmall, goldLight10 } from '../../constants/principles'
import ExclamationTriangle from '../generic/ExclamationTriangle'
import { BrowserUtils } from '../../utils/siteUtils'

export default ({ setShowModal, duplicateInfo, vinModalInfo }) => {
  const { offerId, userId } = duplicateInfo || {}
  return (
    <Modal name="DuplicateOfferModal" open={!!duplicateInfo && !!vinModalInfo && !vinModalInfo.vinModal}>
      <ModalPad>
        <ModalTitle>
          <FlexRowDiv>
            <StyledTriangle>
              <ExclamationTriangle colorFill={goldLight10} width={24} height={24} />
            </StyledTriangle>
            Matching Offer Found
          </FlexRowDiv>
        </ModalTitle>
        <StyledModalContent>
          <p>Please use the existing offer.</p>
        </StyledModalContent>
        <div>
          <DoneButton
            onClick={e => {
              BrowserUtils.postDuplicateOffer(offerId, userId)
              setShowModal(false)
            }}>
            Open Offer
          </DoneButton>
          <DoneButton onClick={e => setShowModal(false)}>Cancel</DoneButton>
        </div>
      </ModalPad>
    </Modal>
  )
}

const StyledTriangle = styled(FlexRowDiv)`
  padding-right: 8px;
`
const ModalPad = styled.div`
  padding: 16px;
`
const ModalTitle = styled.h2`
  margin: 0px;
  padding-bottom: 16px;
  font-size: ${fontSizeSmall};
`
const StyledModalContent = styled(ModalContentNormal)`
  font-size: ${fontSize2XSmall};
  padding: 10px 0;
  overflow: hidden;
  -ms-overflow-style: none;
  width: 280px;
`
const DoneButton = styled(Button)`
  margin: 16px 8px 0px 8px;
`
